<template>
  <div class="job-fair-page">
    <Hero :event="event" />
    <SectionNav />
    <EventDetails :event="event" />
    <Agenda :agenda="eventData.agenda" />
    <Speakers :speakers="eventData.speakers" />
    <Exhibitors v-if="exhibitors.length" :exhibitors="regularExhibitors" :sponsors="sponsors" />
    <Jobs v-if="jobs.length" :jobs="jobs" />
    <PastEvents :pastEvents="eventData.pastEvents" />
    <RegisterCTA />
  </div>
</template>

<script>
import axios from "axios";
import Hero from "~/components/job-fair/Hero.vue";
import SectionNav from "~/components/job-fair/SectionNav.vue";
import EventDetails from "~/components/job-fair/EventDetails.vue";
import Agenda from "~/components/job-fair/Agenda.vue";
import Speakers from "~/components/job-fair/Speakers.vue";
import Exhibitors from "~/components/job-fair/Exhibitors.vue";
import Jobs from "~/components/job-fair/Jobs.vue";
import PastEvents from "~/components/job-fair/PastEvents.vue";
import RegisterCTA from "~/components/job-fair/RegisterCTA.vue";
import eventData from "~/content/job-fair/data.json";

export default {
  name: "MacherJobFair",
  layout: "default",
  components: {
    Hero,
    SectionNav,
    EventDetails,
    Agenda,
    Speakers,
    Exhibitors,
    Jobs,
    PastEvents,
    RegisterCTA,
  },
  data() {
    return {
      eventData,
      jobFair: null,
      exhibitors: [],
      jobs: [],
      head: {
        title: "Macher Job Fair 2026 - Connect with Top Employers",
        description:
          "Join the Macher Job Fair 2026 in Brooklyn, NY. Meet 50+ employers, attend career workshops, and find your next opportunity in the Jewish professional community.",
      },
    };
  },
  computed: {
    sponsors() {
      return this.exhibitors.filter(e => e.BoothType === 3);
    },
    regularExhibitors() {
      return this.exhibitors.filter(e => e.BoothType !== 3);
    },
    event() {
      const base = this.eventData.event;
      if (!this.jobFair) return base;

      return {
        ...base,
        title: this.jobFair.JobFairName || base.title,
        date: this.formatDate(this.jobFair.EventDate) || base.date,
        time: this.formatTimeRange(this.jobFair.StartTime, this.jobFair.EndTime) || base.time,
        venue: this.jobFair.VenueName || base.venue,
        address: this.jobFair.Address || base.address,
      };
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const [year, month, day] = String(dateStr).slice(0, 10).split('-').map(Number);
      const d = new Date(year, month - 1, day);
      return d.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    formatTimeRange(start, end) {
      if (!start || !end) return "";
      const fmt = (t) => {
        const match = String(t).match(/T(\d{2}):(\d{2})/);
        if (!match) return t;
        let hours = parseInt(match[1], 10);
        const minutes = match[2];
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${hours}:${minutes} ${ampm}`;
      };
      return `${fmt(start)} - ${fmt(end)}`;
    },
  },
  async asyncData({ app }) {
    const result = { jobFair: null, exhibitors: [], jobs: [] };
    try {
      const [jobFairRes, exhibitorsRes, jobsRes] = await Promise.all([
        axios.get(process.env.fullBaseApi + "/job-fair/active"),
        axios.get(process.env.fullBaseApi + "/job-fair/exhibitors"),
        axios.get(process.env.fullBaseApi + "/job-fair/jobs"),
      ]);
      const record = jobFairRes?.data?.data?.recordset?.[0];
      if (record) result.jobFair = record;
      result.exhibitors = (exhibitorsRes?.data?.data?.recordset || []).filter(e => e.PaymentStatus === 1);
      result.jobs = jobsRes?.data?.data?.recordset || [];
    } catch (e) {}
    return result;
  },
  head() {
    const { path = "" } = this.$route;
    const metaTitle = this.jobFair && this.jobFair.JobFairName
      ? `${this.jobFair.JobFairName} - Macher Jobs`
      : this.head.title;
    const metaDescription = this.head.description;
    const canonical = process.env.baseUrl + path;

    return {
      title: metaTitle,
      link: [{ rel: "canonical", href: canonical }],
      meta: this.createMetaTags({
        description: metaDescription,
        title: metaTitle,
        canonical,
        socialTitle: metaTitle,
        socialDescription: metaDescription,
        siteName: "Macher Jobs",
        twitter: "@FrumJewishJobs",
      }),
    };
  },
};
</script>

<style lang="scss" scoped>
.job-fair-page {
}
</style>

<style>
@media (max-width: 768px) {
  .job-fair-page .padding-top-65 {
    padding-top: 30px !important;
  }
  .job-fair-page .padding-bottom-65 {
    padding-bottom: 30px !important;
  }
}
</style>
